import React from 'react'
import { Link } from "react-router-dom";

const ListCard = (props) => {
    let className;
    let buttonClass;
    if (props.Status === 'Closed') {
        className = 'card-status g';
        buttonClass = 'btn btn-green';
    }
    else if (props.Status === 'Draft') {
        className = 'card-status o';
        buttonClass = 'btn btn-orange';
    }
    else {
        className = 'card-status';
        buttonClass = 'btn btn-red';
    }

    const [color, label] = props.Riskscore.split(" -");
    return (
        <div className="listCard">

            <div className={className}>
                <span>{props.Status}</span>
            </div>
            <ul>
                <li>Report Number</li>
                <li>{props.ReportNumber}</li>
            </ul>
            <ul>
                <li>Airport Name</li>
                <li>{props.AirportName}</li>
            </ul>
            <ul>
                <li>ICAO Code</li>
                <li>{props.ICAOCode}</li>
            </ul>
            <ul>
                <li>Date</li>
                <li>{props.Date}</li>
            </ul>
            <ul>
                <li>Time</li>
                <li>{props.Time}</li>
            </ul>
            <ul>
                <li>Case Type</li>
                <li>{props.CaseType}</li>
            </ul>
            <ul>
                <li>Classification</li>
                <li>{props.Classification}</li>
            </ul>
            <ul className='bgdata' style={{ backgroundColor: color }}>
                <li>Risk Score</li>
                <li>{label}</li>
            </ul>

            {props.Status === 'Closed' ?
                <div className="button_box">
                    <button onClick={() => props.finalReport(props.Slug, props.Classification, props.CaseType, props.Time, props.Date, props.ICAOCode)} className='btn btn-green'>View Report</button>
                </div>
                :
                <div className="button_box">
                    <button onClick={() => props.initialReport(props.PDFUrl, props.Slug, props.Classification, props.CaseType, props.Time, props.Date, props.ICAOCode)} className='btn btn-black'>Initial Report</button>
                    <Link to={`/case/${props.Slug}`} className={buttonClass}>View Details</Link>
                </div>
            }
        </div>
    )
}

export default ListCard